export default __webpack_public_path__ + "static/Servicio Casillero-9c0f43d75bf620b3b5b67749ec140cc5.svg";